import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/withdrawals-setup')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
